export default "__VITE_ASSET__D6aR7LKF__"